import React from "react";
import { Modal } from "react-bootstrap";
import { useGlobalValue } from "../utils/GlobalState";

export default function Loading() {
  const [{ isLoading }] = useGlobalValue();

  return (
    <Modal show={isLoading} onHide={() => {}}>
      <div
        className="text-center"
        style={{
          backgroundColor: "white",
          borderRadius: 30,
          minHeight: 300
        }}
      >
        <br />
        <br />
        <h3>Loading...</h3>
        <br />
        <div id="loadingBox">
          <div className="loader">
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__bar"></div>
            <div className="loader__ball"></div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
